import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Crypto Redux States
import {  DASHBOARD_USER_DATA } from "./actionTypes";
import { apiFail, loadUserData } from "./actions";
import service from "../../api/monitor.service"


function* loadBoardUserData(filter) {
    try {
        const response = yield call(service.getUserData, filter.payload)
        const error = response?.response?.data?.error
        if (error) {
            yield put(apiFail(DASHBOARD_USER_DATA,error))
        } else {
            yield put(loadUserData(response?.data))
        }


    } catch (error) {
        yield put(apiFail(error.message))
    }
}



export function* watchGetChartsData() {
    yield takeEvery(DASHBOARD_USER_DATA, loadBoardUserData);
}

function* dashboardSaga() {
    yield all([fork(watchGetChartsData)]);
}

export default dashboardSaga;
